<template>
  <button
    type="button"
    class="flex cursor-pointer items-center justify-between rounded-full bg-primary/20 px-3 py-1 text-sm"
  >
    <slot />
  </button>
</template>
